import Button from "components/base/Button";
import errorIllustration from "assets/img/spot-illustrations/404-illustration.png";
import dark404illustrations from "assets/img/spot-illustrations/dark_404-illustration.png";
import error404 from "assets/img/spot-illustrations/404.png";
import darkError40 from "assets/img/spot-illustrations/dark_404.png";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useSettingsMountEffect from "hooks/useSettingsMountEffect";

const Error404 = () => {
  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true,
  });
  return (
    <div>
      <div className="px-3">
        <Row className="min-vh-100 flex-center p-5">
          <Col xs={12} xl={10} xxl={8}>
            <Row className="justify-content-center align-items-center g-5">
              <Col xs={12} lg={6} className="text-center order-lg-1">
                <img
                  src={errorIllustration}
                  alt=""
                  width={400}
                  className="img-fluid w-lg-100 d-dark-none"
                />
                <img
                  src={dark404illustrations}
                  alt=""
                  width={540}
                  className="img-fluid w-md-50 w-lg-100 d-light-none"
                />
              </Col>
              <Col xs={12} lg={6} className="text-center text-lg-start">
                <img
                  src={error404}
                  className="img-fluid mb-6 w-50 w-lg-75 d-dark-none"
                  alt=""
                />
                <img
                  src={darkError40}
                  className="img-fluid mb-6 w-50 w-lg-75 d-light-none"
                  alt=""
                />
                <h2 className="text-body-secondary fw-bolder mb-3">
                  Page not found
                </h2>
                <p className="text-body mb-5">
                  The page you're looking for doesn't exist or may have moved.
                  <br className="d-none d-sm-block" />
                  If you followed a link from an email and landed here, please
                  contact our team and we'll get you sorted right away.
                </p>
                <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start">
                  <Button variant="primary" size="lg" as={Link} to="/sign-in">
                    Sign In
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    as="a"
                    href="mailto:support@kairosiq.ai?subject=Help%20with%20KairosIQ"
                  >
                    Contact Support
                  </Button>
                  <Button variant="link" size="lg" as={Link} to="/">
                    Go Home
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Error404;
